import type { SetStateAction } from "react";

import { Ellipsis, Pause, Play } from "lucide-react";

import {
  MentorProfileStatus,
  useMentorProfile,
  usePauseMentorProfileAsAdmin,
} from "@/entities/mentors-profile";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";
import { MentorProfilePreviewModal } from "./MentorProfilePreviewModal";
import { Skeleton } from "@/shared/ui/skeleton";

export const PauseMentorProfileDropdown = ({
  mentorUserId,
  open,
  setOpen,
}: {
  mentorUserId: string;
  open: boolean;
  setOpen: React.Dispatch<SetStateAction<boolean>>;
}) => {
  const { data, isPending, isFetching } = useMentorProfile({
    userId: mentorUserId,
    enabled: open,
  });
  const toggleProfile = usePauseMentorProfileAsAdmin();

  function renderButtons() {
    if (!data?.data) return;
    const mentorProfile = data.data;
    const isPaused = mentorProfile?.status !== MentorProfileStatus.ACTIVE;

    return (
      <>
        <MentorProfilePreviewModal mentorProfile={mentorProfile} />
        <DropdownMenuItem
          className="justify-between"
          onClick={() => toggleProfile(mentorProfile)}
        >
          {isPaused ? (
            <>
              <span>Возобновить</span> <Play />
            </>
          ) : (
            <>
              <span className="text-red-500">Поставить на паузу</span>{" "}
              <Pause className="stroke-red-500" />
            </>
          )}
        </DropdownMenuItem>
      </>
    );
  }

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger>
        <Ellipsis />
      </DropdownMenuTrigger>

      <DropdownMenuContent>
        {isPending || isFetching ? (
          <Skeleton className="h-12 w-full" />
        ) : !data?.data ? (
          <DropdownMenuItem disabled>Ментор профиль не найден</DropdownMenuItem>
        ) : (
          renderButtons()
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
